import { render, staticRenderFns } from "./enableShiftReports.vue?vue&type=template&id=87b1c940&scoped=true"
import script from "./enableShiftReports.vue?vue&type=script&lang=js"
export * from "./enableShiftReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b1c940",
  null
  
)

export default component.exports